import { useTranslation } from 'react-i18next';
import { ILoadHistoryEventResponse } from '../../../../interfaces/ILoadHistoryResponse';
import LoadHistoryUtils from '../../utils/load-history-drawer.utils';

function HistoryItemVisibilityChanged({
    history,
}: Readonly<{
    history: ILoadHistoryEventResponse;
}>) {
    const { t } = useTranslation();
    return (
        <div
            key={history.eventDate.toString()}
            className="load-history-event-container load-history-line"
            data-testid="load-history-event"
        >
            <div className="load-history-section-title">
                <h4 className="load-history-event-type">
                    {t('LoadHistory.Events.VisibilityChangedHistory')}
                </h4>
            </div>
            <span>
                {LoadHistoryUtils.getDateTimeLabel(
                    history.metadata.roundStartDate ?? history.eventDate,
                )}
            </span>
            <span>Carga visível a todos transportadores</span>
        </div>
    );
}

export default HistoryItemVisibilityChanged;

